<template>
  <b-card
    no-body
    class="card-payment"
  >
    <b-card-body>
      <b-card-text>
        <b-card
          no-body
          class="mb-0"
        >
          <b-form>
            <b-row>
              <b-col
                v-if="listQuestion.length>0"
                sm="8"
              >
                <ul
                  v-for="listQues in listQuestion"
                  :key="listQues.index"
                  style="list-style-type:circle; margin-left:-8%"
                >
                  <li
                    v-if="listQues.questionType === 'integer' || listQues.questionType === 'decimal' || listQues.questionType === 'note'"
                  >
                    <b-badge
                      pill
                      variant="primary"
                      class="active-a-variable"
                    >
                      <a
                        href="javascript:void(0)"
                        @click="addVariable(listQues)"
                      >
                        {{ listQues.name }}
                      </a>
                    </b-badge>
                  </li>
                </ul>
              </b-col>
              <b-col
                sm="4"
              >
                <ul
                  v-for="oper in operators"
                  :key="oper.index"
                  style="list-style-type:circle"
                >
                  <li>
                    <b-badge
                      pill
                      class="active-a-variable"
                    >
                      <a
                        href="javascript:void(0)"
                        @click="addOperador(oper)"
                      >
                        {{ oper }}
                      </a>
                    </b-badge>
                  </li>
                </ul>
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col
                sm="12"
              >
                <b-form-input
                  id="formula"
                  v-model="formulaResult"
                  placeholder="Formula de pregunta..."
                  trim
                />
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BForm, BCardText, BFormInput, BBadge,
} from 'bootstrap-vue'
import { _ } from 'vue-underscore'
import { showToast } from '@/helpers'

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BForm,
    BCardText,
    BFormInput,
    BBadge,
  },
  emits: ['update:is-busy-clonar', 'update:modal-show', 'update:data-edit'],
  props: {
    typeAction: {
      type: String,
      required: true,
    },
    listQuestion: {
      type: Array,
      default: () => [],
    },
    formula: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      formulaResult: this.formula,
      count: 0,
      type: '',
      operators: ['+', '-', '*', '/', '%'],
    }
  },
  methods: {
    addVariable(data) {
      const variable = data.name
      this.generateFormula(variable)
    },
    addOperador(oper) {
      this.generateFormula(oper)
    },
    generateFormula(data) {
      let bval = true
      const statusDat = this.formulaOperators(data)
      if (statusDat && (this.count === 0 || this.formulaResult === '')) {
        this.showToast('Advertencia', 'El operador debe ser ingresado correctamente', 'warning')
        bval = false
        this.count = 0
      }
      if (bval) {
        this.formulaResult = ` ${this.formulaResult}${data}`
        this.formulaResult = this.formulaResult.trim()
        this.count += 1
      }
    },
    saveForm() {
      this.$emit('refresh-data', this.formulaResult)
      this.count = 0
      this.$emit('update:modal-show', false)
    },
    formulaOperators(operator) {
      const operators = ['+', '-', '*', '/', '%', 'div', '=', '!=', '<', '<=', '>', '>=', 'or', 'and', 'mod']
      const result = _.contains(operators, operator)
      return result
    },
    showToast,
  },
}
</script>
<style lang="scss" scoped>
.active-a-variable:hover {
  background-color:#b8c2cc;
}
</style>
